import { Component } from '@angular/core';

import { DateAdvancedFilterModel, ICellEditorParams, JoinAdvancedFilterModel } from 'ag-grid-enterprise';

import { DatePickerComponent } from '@camelot/form-input';

import { BaseEditorComponent } from '../base-col';
import type { TimeCol } from './time-col';

@Component({
  host: { 'data-cid': 'time-editor' },
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '',
  imports: [DatePickerComponent],
  template: ` @if (this.input) {
    <div class="p-space-sm">
      <cam-input-date-picker
        [input]="$any(this.input)"
        [standalone]="true"
        [onFocus]="this.focus$"
      ></cam-input-date-picker>
    </div>
  }`,
})
export class TimeEditorComponent extends BaseEditorComponent<
  JoinAdvancedFilterModel | DateAdvancedFilterModel,
  TimeCol
> {
  override agInit(params: ICellEditorParams) {
    super.agInit(params);
  }

  getValue() {
    return this.input?.value ?? null;
  }
}
